import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function GlobalHelpButton() {
  const handleHelpClick = () => {
    window.dispatchEvent(new CustomEvent('start-onboarding-tour'));
  };

  return (
    <div className="fixed top-4 right-4 z-[60]">
      <Button
        onClick={handleHelpClick}
        variant="outline"
        size="icon"
        className="rounded-full shadow-lg bg-background/80 backdrop-blur-md border-border hover:bg-accent hover:text-accent-foreground text-foreground transition-all duration-300 hover:scale-105"
        title="Ver ayuda de esta página"
        aria-label="Ver ayuda de esta página"
      >
        <HelpCircle className="w-5 h-5 text-teal-600 dark:text-teal-400" />
      </Button>
    </div>
  );
}
